import * as i0 from "@angular/core";
export class LocaleService {
    constructor() {
        this.localeParam = null;
        this.isAvailable = false;
    }
    // noinspection JSUnusedGlobalSymbols
    getLocaleParam() {
        return this.localeParam;
    }
    setLocaleParam(value) {
        this.localeParam = value;
    }
    getIsAvailable() {
        return this.isAvailable;
    }
    setIsAvailable(value) {
        this.isAvailable = value;
    }
}
LocaleService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LocaleService_Factory() { return new LocaleService(); }, token: LocaleService, providedIn: "root" });
